import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import Container from "@mui/material/Container";
import { CICard } from "../../Shared/CICard/CICard";
import { PriorityAlert } from "components/Shared/PriorityAlert";
import { Button } from "components/Shared/Inputs";

export const TimesheetTab: FunctionComponent = () => {
    const { t, ready: translationsReady } = useTranslation('criticalIncident', { useSuspense: false });

    return translationsReady ? (
        <Container className="ci_timesheet">
          <CICard className="case_summary_paper">
            <h2>{t('timesheet_and_expenses')}</h2>
            <PriorityAlert priority="normal">
              <div dangerouslySetInnerHTML={{ __html: t('timesheet_tab_content') }} />
            </PriorityAlert>
            <Button LinkComponent={"a"} variant="outline" href={t('timesheet_template_url')} target="_blank" rel="noopener noreferrer">{t('download_template')}</Button>
          </CICard>
        </Container>
    ) : null;
};
